export enum ActionType {
    ORDER_ERROR="ORDER_ERROR"
}

interface IOrderError {
    type: ActionType.ORDER_ERROR,
    payload: string
}

export type Action = IOrderError;